import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-log-apontamentos',
  templateUrl: './log-apontamentos.component.html',
  styleUrls: ['./log-apontamentos.component.scss'],
})
export class LogApontamentosComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
